import './App.css';
import { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './components/firebaseConfig';
import Loader from './components/Loader';
import Dashboard from './components/pages/Dashboard';
import Login from './components/pages/Login';
function App() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Kullanıcı durumu izleme
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setIsLoading(false); // Yükleme tamamlanınca false yap
    });

    return unsubscribe; // Temizleme işlemi
  }, []);

  if (isLoading) {
    return <Loader />; // Yüklenme sırasında preloader göster
  }

  return (
    <div className="bg-white h-screen overflow-hidden flex flex-col justify-between">
      <Toaster position="top-right" reverseOrder={false} />
      {user ? <Dashboard /> : <Login />} {/* Kullanıcı durumuna göre sayfa göster */}
    </div>
  );
}

export default App;
